





import { defineComponent } from "@vue/composition-api";
import BaseButton from "@/components/BaseButton";
import BaseIcon from "@/components/BaseIcon";

export default defineComponent({
  name: "PreviewSetButton",
  components: { BaseButton, BaseIcon },
  props: {
    public: { type: Boolean, required: true },
    wrapperStyle: {
      type: Object as () => Record<string, string>,
      default: () => ({ width: "26px", height: "26px" }),
    },
    iconSize: { type: String, default: "13px" },
  },
});
